/**
 * ActivateAccountGuest.js — Account activation landing page (guest checkout users).
 *
 * Reads activationUrl, userid, and email from the query string, generates a
 * random password, calls the customerActivateByUrl Shopify mutation to activate
 * the Shopify account, then notifies the engine API (activate_account_new.php)
 * to sync the activation status. Shows a login button on success.
 *
 * Props:
 *  - EngineURL {string}         Base URL for the engine REST API.
 *  - ShowLoginPopup {Function}  Opens the login modal (shown on success).
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, {useState, useEffect} from "react";
import {Button, Modal, Container, Row, Col, Alert, Form} from "react-bootstrap";
import {useMutation} from "@apollo/react-hooks";
import {useLocation} from "react-router";
import queryString from "query-string";
import axios from "axios";

// ─── GraphQL ──────────────────────────────────────────────────────────────────
import {customerActivateByUrl} from "../grappql/Customers/Mutations/customerActivateByUrl";

export const ActivateAccountGuest = (props) => {
  const location = useLocation();

  const queryParam = queryString.parse(location.search);

  if (queryParam["activationUrl"] === undefined) {
    window.location.href = "/";
  }

  const ResetUrl = queryParam["activationUrl"] !== undefined && queryParam["activationUrl"] !== null ? queryParam["activationUrl"] : undefined;
  const userid = queryParam["userid"] !== undefined && queryParam["userid"] !== null ? queryParam["userid"] : undefined;

  const [ErrorMessage, setErrorMessage] = useState(undefined);
  const [SuccessMessage, setSuccessMessage] = useState(undefined);
  const [SomethingUpadating, setSomethingUpadating] = useState(false);

  const [ResetPassword, {data: recovered_data}] = useMutation(customerActivateByUrl);

  /**
   * Generates a 10-character random password from alphanumeric + symbol charset.
   * Used because Shopify requires a password when activating via URL — the user
   * logs in via the normal login flow rather than using this password directly.
   * @returns {string} Random password string.
   */
  const genereateRandomPassword = () => {
    const length = 10;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      password += charset.charAt(Math.floor(Math.random() * n));
    }
    return password;
  };
  const user_password = genereateRandomPassword();
   
  /**
   * Form submit handler. Fires the customerActivateByUrl mutation with the
   * activation URL and a randomly generated password.
   * @param {React.SyntheticEvent} e - Form submit event.
   */
  const submit = (e) => {
    e.preventDefault();
    setErrorMessage(undefined);
    setSuccessMessage(undefined);
    setSomethingUpadating(false);

    setSomethingUpadating(true);
    ResetPassword({
      variables: {
        activationUrl: ResetUrl,
        password: user_password,
      },
    });
  };

  /** Opens the login modal via the ShowLoginPopup prop. */
  const openLoginPopup = () => {
    props.ShowLoginPopup();
  };

  useEffect(() => {
    if (recovered_data !== undefined) {
      if (recovered_data.customerActivateByUrl.customerUserErrors !== undefined && recovered_data.customerActivateByUrl.customerUserErrors.length) {
        recovered_data.customerActivateByUrl.customerUserErrors.forEach(function (error) {
          setErrorMessage(error.message);
          setSomethingUpadating(false);
        });
      } else {
        //update register form detail to user
        axios
          .get(props.EngineURL + "create-account/activate_account_new.php?userid=" + userid + "&token=" + ResetUrl)
          .then(function (response) {
            setTimeout(function () {
              if (response.data.code === 200) {
                if (response.data.message === "user account activated") {
                  setSuccessMessage("Your account has been activated successfully! Please login now.");
                } else {
                  setSuccessMessage(response.data.message);
                }                
              } else {
                setErrorMessage(response.data.message);
              }
              setSomethingUpadating(false);
            }, 1000);
          })
          .catch(function (error) {
            console.log(error);
          });

        setSomethingUpadating(false);
        setSuccessMessage("Your Account has been activated successfully !");
      }
    }
  }, [recovered_data, ResetUrl, userid, props.EngineURL]);

  return (
    <Container>
      <br />
      <Row className="justify-content-center">
        <Col md={4} xs={12}>
          <Form className="" onSubmit={submit}>
            <Modal.Title className="text-center">Activate your account</Modal.Title>

            {ErrorMessage !== undefined ? <Alert variant="danger">{ErrorMessage}</Alert> : ""}
            {SuccessMessage !== undefined ? (
              <>
                <Alert variant="success">{SuccessMessage}</Alert>
                <Button className="w-100 rounded-2 btn-lg border-2" onClick={(e) => openLoginPopup()}>
                  Login
                </Button>
              </>
            ) : (
              ""
            )}
            {SuccessMessage === undefined ? (
              <Button
                  variant="primary"
                  type="submit"
                  className="w-100 rounded-2 btn-lg border-2"
                  disabled={SomethingUpadating}
              >
                  {SomethingUpadating ? 'Validating....' : 'Submit'}
              </Button>
          ) : (
              ""
          )}
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
